import { useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";
import { useAtomValue, useSetAtom } from "jotai";
import { edgesAtom, nodesAtom, startTourSetter } from "@zapier/canvas-state";
import { useComposer } from "@zapier/agent-system";

export function useStartTourFromQueryParams() {
  const searchParams = useSearchParams();
  const tourSearchParam = searchParams?.get("tour");
  const shouldStartTour = tourSearchParam === "true";
  const hasStartedTour = useRef(false);
  const nodes = useAtomValue(nodesAtom);
  const edges = useAtomValue(edgesAtom);
  const { handleSubmit } = useComposer();
  const startTour = useSetAtom(startTourSetter);

  useEffect(() => {
    if (shouldStartTour && !hasStartedTour.current) {
      hasStartedTour.current = true;
      startTour({
        composerHandleSubmit: handleSubmit,
      });
    }
  }, [shouldStartTour, startTour, nodes, edges]);
}
